"use client";

import { useEffect } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';

export const useUrlParamCleanup = () => {
  const router = useRouter();
  const searchParams = useSearchParams();

  const cleanupParams = (paramsToRemove) => {
    const newUrl = new URL(window.location);
    paramsToRemove.forEach(param => {
      newUrl.searchParams.delete(param);
    });
    router.replace(newUrl.pathname + newUrl.search);
  };

  const handleAccountSelection = (accountType) => {
    cleanupParams([`${accountType}_connected`]);
  };

  return { cleanupParams, handleAccountSelection };
};